import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {firestore} from "../firebase";
import {doc, getDoc} from "firebase/firestore";
import {Button} from "react-bootstrap";
import "./School.css";

const Home = () => {
  const [schoolName, setSchoolName] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (role) => {
    try {
      const docRef = doc(firestore, "login", schoolName);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const isValidPassword =
          role === "Teacher" ? data.t === password : data.s === password;

        if (isValidPassword) {
          console.log(`login successful` + schoolName);

          if (role === "Teacher" && schoolName === "a") {
            navigate(`/schoollist`, {
              state: {
                schoolName,
                schoolCode: data.c,
                schoolUrl: data.u,
              },
            });
          } else if (role === "Teacher") {
            navigate(`/teacher`, {
              state: {
                schoolName,
                schoolCode: data.c,
                schoolUrl: data.u,
              },
            });
          } else {
            window.open(data.u, "_blank");
          }
        } else {
          console.error("Login failed: Invalid password");
          alert("비밀번호가 올바르지 않습니다.");
        }
      } else {
        console.error("Login failed: School not found");
        alert("학교를 찾을 수 없습니다.");
      }
    } catch (error) {
      console.error("Error fetching school data:", error);
      alert("데이터를 가져오는 중 오류가 발생했습니다.");
    }
  };

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div style={{textAlign: "center"}}>
        <h1 className="text-center">초코파이썬</h1>
        <p className="text-truncate-2 mb-2">개인 또는 단체를 선택하세요!</p>

        <div className="card">
          <Link to="/personalHome" className="g-1">
            <Button variant="primary" size="lg" className="card-img-top">
              개인 학습자
            </Button>
          </Link>
        </div>
        <div className="card">
          <Link to="/newschool" className="g-1">
            <Button variant="success" size="lg" className="card-img-top">
              학교 / 기업 / 단체 학습자
            </Button>
          </Link>
        </div>
        <div className="py-4">
          <a href="https://chocopython.org"><i className="fas fa-home"></i>chocopython.org</a>
        </div>
      </div>
    </section>
  );
};

export default Home;
